var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "add-new-chat" } },
    [
      _c(
        "div",
        {
          staticClass: "material-icons close-add-user-page",
          on: { click: _vm.closeAddUserPage },
        },
        [_vm._v("close")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "selected-user-input row" }, [
        _c(
          "span",
          { staticStyle: { display: "contents" } },
          [
            _vm._l(_vm.selectedMembers, function (selectedMember) {
              return _c("span", { staticClass: "selected-user-item row" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(selectedMember.name) +
                    "\n                "
                ),
                _c(
                  "span",
                  {
                    staticClass: "material-icons closeIcon",
                    on: {
                      click: function ($event) {
                        return _vm.cancelSelectMember(selectedMember)
                      },
                    },
                  },
                  [_vm._v(" cancel ")]
                ),
              ])
            }),
            _vm._v(" "),
            _c("a-input", {
              staticClass: "input-select",
              attrs: {
                placeholder: _vm.$t("message.selectPeople"),
                name: "search",
              },
              model: {
                value: _vm.searchValue,
                callback: function ($$v) {
                  _vm.searchValue = $$v
                },
                expression: "searchValue",
              },
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "span",
          [
            _vm.selectedMembers.length > 0
              ? _c(
                  "md-button",
                  {
                    key: "members" + _vm.selectedMembers.length,
                    on: { click: _vm.createChatOrAddUserGroup },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "next-btn" },
                      [
                        _vm._v(
                          _vm._s(
                            !!_vm.addUserInGroup
                              ? _vm.$t("message.add")
                              : _vm.$t("message.next")
                          )
                        ),
                        _c("send-icon", {
                          staticStyle: { "margin-left": "10px" },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _c("md-button", { attrs: { disabled: "" } }, [
                  _c("span", { staticClass: "next-btn-disabled" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          !!_vm.addUserInGroup
                            ? _vm.$t("message.add")
                            : _vm.$t("message.next")
                        ) +
                        "\n                    "
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "material-icons",
                        staticStyle: {
                          "margin-left": "5px",
                          "font-size": "20px",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        arrow_forward_ios\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "vue-scroll",
        _vm._l(_vm.searchUser, function (user) {
          return _c("newGroupMember", {
            key: user._id,
            attrs: {
              row: user,
              "on-select-member": function () {
                return _vm.selectMember(user)
              },
              selectedMembers: _vm.selectedMembers,
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.newGroupModalVisible && _vm.selectedMembers.length > 1
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.enterGroupTitle"),
                id: "create-new-group",
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.newGroupModalVisible = false
                },
              },
            },
            [
              _c("a-input", {
                attrs: { placeholder: _vm.$t("message.title") },
                model: {
                  value: _vm.newGroupTitle,
                  callback: function ($$v) {
                    _vm.newGroupTitle = $$v
                  },
                  expression: "newGroupTitle",
                },
              }),
              _vm._v(" "),
              !_vm.newGroupTitle
                ? _c(
                    "div",
                    { staticStyle: { color: "red", "font-size": "small" } },
                    [_vm._v(_vm._s(_vm.$t("message.requiredTitle")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "margin-top": "30px",
                  },
                },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "add-segment-confirm-btn",
                      on: { click: _vm.createNewGroup },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("visitor.confirm")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }